import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request whose caller turns a `409` into its own prompt (the
 * maintenance conflict list), so the generic error toast stays quiet for it.
 * Every other status is still reported as usual.
 */
export const HANDLES_CONFLICT = new HttpContextToken<boolean>(() => false);

/**
 * Set on a background request nobody is waiting on (a badge count that polls).
 * Its failure must not toast every few seconds; only a refused session is still
 * reported, because that one the user has to act on.
 */
export const BACKGROUND_REQUEST = new HttpContextToken<boolean>(() => false);
